import { ReactNode } from 'react';

import { Alert, Button, Tabs, Tooltip } from 'antd';
import { T, TF } from 'react-translator-component';

import { ConnectorBar, StatusDot } from './styled';

interface DoorConnectorListItem {
  connectorId: number;
  label: string;
  enabled: boolean;
  configured: boolean;
}

interface DoorConnectorListProps {
  items: DoorConnectorListItem[];
  selectedId: number | null;
  onSelect: (connectorId: number) => void;
  error: string | null;
  onRetry: () => void;
  renderPanel: (connectorId: number) => ReactNode;
}

const stateText = (item: DoorConnectorListItem): string => {
  const enabled = TF(item.enabled ? 'Door enabled' : 'Door disabled');
  const configured = TF(item.configured ? 'Configured' : 'Door not configured');
  return `${enabled} · ${configured}`;
};

const DoorConnectorList = ({
  items,
  selectedId,
  onSelect,
  error,
  onRetry,
  renderPanel,
}: DoorConnectorListProps) => (
  <ConnectorBar>
    {error && (
      <Alert
        type='error'
        showIcon
        style={{ marginBottom: 16 }}
        message={T('Could not load the door settings.')}
        description={error}
        action={
          <Button size='small' onClick={onRetry}>
            {T('Try again')}
          </Button>
        }
      />
    )}
    <Tabs
      activeKey={selectedId == null ? undefined : String(selectedId)}
      onChange={(key) => onSelect(Number(key))}
    >
      {items.map((item) => (
        <Tabs.TabPane
          key={String(item.connectorId)}
          tab={
            <Tooltip title={error ? undefined : stateText(item)}>
              <span>
                {!error && (
                  <StatusDot $on={item.enabled && item.configured} />
                )}
                {item.label}
              </span>
            </Tooltip>
          }
        >
          {renderPanel(item.connectorId)}
        </Tabs.TabPane>
      ))}
    </Tabs>
  </ConnectorBar>
);

export default DoorConnectorList;
